import { Component, OnInit } from '@angular/core';
import { AppSingle } from '../../app-single';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductService } from '../../services/product.service';
import { NotificationService } from '../../notification/swal/notification.service';
import { ProductModel } from '../../models/product.model';

@Component({
  selector: 'app-restriction',
  templateUrl: './restriction.component.html',
  styleUrls: ['./restriction.component.less']
})
export class RestrictionComponent extends AppSingle implements OnInit {

  categories = new Array<any>();

  constructor(route: ActivatedRoute, private router: Router, private productService: ProductService,
    private notificationService: NotificationService) {
    super(route);
  }

  formatCategory(products: ProductModel[]) {
    const _categories = [];
    const result = [];
    products.forEach((product: ProductModel) => {
      _categories[product.categoryName] = product.categoryId;
    });
    for (const key in _categories) {
      if (_categories[key]) {
        result.push({name: key, id: _categories[key]});
      }
    }
    return result;
  }

  ngOnInit() {
    this.productService.getAll(this.companyId)
      .then((_products: ProductModel[]) => {
        const categories = this.formatCategory(_products);
        this.categories = categories;
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }

  goToSingle(categoryId: string) {
    this.router.navigate([`general/dependentesSingle/${this.id}/restricoes/${this.companyId}/restricaoSingle/${categoryId}/${this.tipo}`]);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/restriction/restriction.component.ts